import React from 'react'
import { motion } from 'framer-motion'
import {
  animationAppTransitions,
  animationAppVariants
} from '../component/Helpers/pageAnimation'
import BudgetList from '../component/Budget/BudgetList'

const SurgicalBudget: React.FC = () => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={animationAppVariants}
      transition={animationAppTransitions}
    >
      <BudgetList />
    </motion.div>
  )
}

export default SurgicalBudget
